export const GET_COOKIE = (cname, isParse = true) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  let cokkie = null;
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      cokkie = c.substring(name.length, c.length);
    }
  }

  if (isParse) {
    return JSON.parse(cokkie) || null;
  }

  return cokkie || null;
};

export const GET_LOCALSTORAGE = name => {
  return JSON.parse(localStorage.getItem(name));
};

export const REMOVE_COOKIE = cname => {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;

    if (name.includes(cname)) {
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }
};

export const GET_CURRENT_DATE = (_date)=> {
  let d = new Date();
  if(_date){
    d = _date
  }
  d.setHours(d.getHours()+7);
  const dISO = d.toISOString();
  const re1 = dISO.replace("T", " ");
  const re2 = re1.replace("Z", "");
  const date = re2.split(' ')[0];
  const yearMonth = date.substr(0, 7);

  let hours = d.getHours() >= 10?d.getHours():`0${d.getHours()}`;
  let minutes = d.getMinutes() >= 10?d.getMinutes():`0${d.getMinutes()}`;
  let seconds = d.getSeconds() >= 10?d.getSeconds():`0${d.getSeconds()}`;
  const time_now = `${hours}:${minutes}:${seconds}`;

  return {
    timestamp: re2.split('.')[0],
    date: date,
    time_now: time_now,
    yearMonth: yearMonth
  };
}

export const CAL_SLA_DATE = (startDateStr, endDateStr) => {  
  const WORK_START_HOUR = 9;
  const WORK_END_HOUR = 18;

  let totalMinutes = 0;  
  let logDetails = [];

  // แปลงเป็น Local Time (จาก UTC)
  let startDate = new Date(startDateStr);
  let endDate = new Date(endDateStr);

  // ใช้เขตเวลาเครื่องที่รัน (แก้ปัญหา UTC)
  startDate = new Date(startDate.getTime() + startDate.getTimezoneOffset() * 60000);
  endDate = new Date(endDate.getTime() + endDate.getTimezoneOffset() * 60000);

  let current = new Date(startDate);

  while (current < endDate) {
      let startTime = new Date(current);
      let endTime = new Date(current);

      let startHour = current.getHours();
      let startMinute = current.getMinutes();
      let endHour = WORK_END_HOUR;
      let endMinute = 0; // นาทีของ end time

      // ถ้าวันนี้เป็นวันสุดท้าย ใช้เวลาสิ้นสุดเป็นเกณฑ์
      if (current.toDateString() === endDate.toDateString()) {
          endHour = Math.min(endHour, endDate.getHours());
          endMinute = endDate.getMinutes(); // นับนาทีของ endDate ด้วย
      }

      // ถ้าเวลาน้อยกว่า 9:00 ให้เริ่มที่ 9:00
      if (startHour < WORK_START_HOUR) {
          startHour = WORK_START_HOUR;
          startMinute = 0;
      }

      // ถ้าช่วงเวลานับรวมอยู่ระหว่าง 9:00 - 18:00
      if (startHour < endHour || (startHour === endHour && startMinute < endMinute)) {
          startTime.setHours(startHour, startMinute, 0, 0);
          endTime.setHours(endHour, endMinute, 0, 0); // นับนาทีของ endTime ด้วย

          let diffMs = endTime - startTime;
          let diffMinutes = diffMs / (1000 * 60); // แปลง ms เป็นนาที
          totalMinutes += diffMinutes;
          logDetails.push({
              date: startTime.toLocaleDateString(),
              start: startTime.toLocaleTimeString(),
              end: endTime.toLocaleTimeString(),
              duration: diffMinutes
          });
      }

      // ไปวันถัดไป เริ่มต้นที่ 00:00
      current.setDate(current.getDate() + 1);
      current.setHours(0, 0, 0, 0);
  }

  // แปลงเป็น ชั่วโมง + นาที
  let hours = Math.floor(totalMinutes / 60);
  let minutes = totalMinutes % 60;

  console.log(`🕒 รวมเวลาทั้งหมด: ${hours} ชั่วโมง ${minutes} นาที`);
  console.log("📅 ช่วงเวลาที่นับรวม:");
  logDetails.forEach(log => {
      let durationHours = Math.floor(log.duration / 60);
      let durationMinutes = log.duration % 60;
      console.log(`- วันที่ ${log.date} ⏳ ${log.start} - ${log.end} (${durationHours} ชั่วโมง ${durationMinutes} นาที)`);
  });

  return { totalHours: hours, totalMinutes: minutes, details: logDetails , totalDuration: totalMinutes };
};

export const FORMAT_TIME = (timeString) => {
  // แปลงเป็นสตริงแล้วแยกส่วน ชั่วโมง กับ นาที
  const [hourStr, minuteStr] = timeString.toString().split('.');

  const hours = parseInt(hourStr, 10);
  const minutes = parseInt(minuteStr ? minuteStr.padEnd(2, '0') : '0', 10); // เติมศูนย์ถ้าจำเป็น

  if (hours > 0 && minutes > 0) {
    return `${hours}h ${minutes.toString().length > 2 ? minutes.toString().slice(0,2) : minutes}m`;
  } else if (hours > 0) {
    return `${hours}h`;
  } else {
    return `${minutes}m`;
  }
};


export const DISPLAY_SLA_TIME = (minutes) => { 
  if (!minutes) return "";

  const days = Math.floor(minutes / (24 * 60)); // Convert to days
  const hours = Math.floor((minutes % (24 * 60)) / 60); // Remaining hours
  const mins = minutes % 60; // Remaining minutes
  
  if (days > 0) {
    return `${days}d ${hours}h`; // Show only days & hours
  }
  return `${hours}h ${mins}m`; // Show only hours & minutes
};

export const CONVET_MINUTES_TO_HOURS = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const result = `${hours}.${mins < 10 ? '0' + mins : mins}`;
  return parseFloat(result);
}

export const CONVET_HOURS_TO_MINUTES = (hours) => {
  const splitHours = hours.toString().split('.');
  const hoursInt = parseInt(splitHours[0]);
  const minutesInt = parseInt(splitHours[1] || '0');
  const minutes = hoursInt * 60 + minutesInt;
  return minutes;
}
